import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';
@Injectable()
export class SellerMRService {

  constructor(private http: Http, private router: Router) { }

  public listMr() {
    console.log('inside services');
    return this.http.get(environment.baseUrl + '/seller/mr', GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public filterMr(sellerMRID: any) {
    console.log('inside services');
    const mrId = sellerMRID;
    const buyerId = sessionStorage.getItem('selectedBuyerId');
    return this.http.get(environment.baseUrl + '/seller/mr/' + buyerId + '/' + mrId , GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public paginationMR(newOffset, limit) {
    console.log('pagination', newOffset, limit);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    headers.append('Access-Control-Allow-Origin', '*');
     return this.http.get(environment.baseUrl + '/seller/mr',
     {headers: headers, params : {
      offset: newOffset,
      limit: limit
     }})
     .map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
 }

    public previousPage(previousUrl) {
     console.log('on previous page', previousUrl);
      return this.http.get(environment.baseUrl + '/seller/mr' + previousUrl, GlobalService.getHeaders())
      .map((response: Response) => {
       console.log(response.status);
       const user = response.json();
       user.responseStatus = response.status;
       console.log(user);
       return user;
     }).catch((error) => {
       console.log('error', error);
       if (error.status === 500) {
         console.log('status', error.status);
         const err = error.json();
         err.responseStatus = error.status;
         console.log('status', err.responseStatus);
         return Observable.throw(err);
       } else if (error.status === 400) {
         console.log('status', error.status);
         const err = error.json();
         err.responseStatus = error.status;
         console.log('status', err.responseStatus);
         return Observable.throw(err);
       } else if (error.status === 401) {
         console.log('status', error.status);
         const err = error.json();
         err.responseStatus = error.status;
         console.log('status', err.responseStatus);
         return Observable.throw(err);
       }
   });
  }

  public NextPage(nextUrl, newOffset, limit) {
   console.log('on next page', nextUrl, newOffset, limit);
   const token = localStorage.getItem('currentUser');
   console.log('token', token);
   const headerToken = 'Bearer ' + token;
   console.log('hk', headerToken);
   const headers = new Headers();
   headers.append('Content-Type', 'application/json');
   headers.append('Authorization', headerToken);
   headers.append('Access-Control-Allow-Origin', '*');
    return this.http.get(environment.baseUrl + '/seller/mr',
    {headers: headers, params : {
     offset: newOffset,
     limit: limit
    }})
    .map((response: Response) => {
     console.log(response.status);
     const user = response.json();
     user.responseStatus = response.status;
     console.log(user);
     return user;
   }).catch((error) => {
     console.log('error', error);
     if (error.status === 500) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     } else if (error.status === 400) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     } else if (error.status === 401) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     }
 });
 }

 public filterMRByURL(offset: any, limit: any) {
   console.log('href on services', offset, limit);
   const token = localStorage.getItem('currentUser');
   console.log('token', token);
   const headerToken = 'Bearer ' + token;
   console.log('hk', headerToken);
   const headers = new Headers();
   headers.append('Content-Type', 'application/json');
   headers.append('Authorization', headerToken);
   headers.append('Access-Control-Allow-Origin', '*');
   return this.http.get(environment.baseUrl  + '/seller/mr', {headers: headers, params : {
     offset: offset,
     limit: limit
    }})
   .map((response: Response) => {
    console.log(response.status);
    const user = response.json();
    user.responseStatus = response.status;
    console.log(user);
    return user;
  }).catch((error) => {
    console.log('error', error);
    if (error.status === 500) {
      console.log('status', error.status);
      const err = error.json();
      err.responseStatus = error.status;
      console.log('status', err.responseStatus);
      return Observable.throw(err);
    } else if (error.status === 400) {
      console.log('status', error.status);
      const err = error.json();
      err.responseStatus = error.status;
      console.log('status', err.responseStatus);
      return Observable.throw(err);
    } else if (error.status === 401) {
      console.log('status', error.status);
      const err = error.json();
      err.responseStatus = error.status;
      console.log('status', err.responseStatus);
      return Observable.throw(err);
    }
 });
 }

   public filterMrOffset() {
    console.log('offset');
   const token = localStorage.getItem('currentUser');
   console.log('token', token);
   const headerToken = 'Bearer ' + token;
   console.log('hk', headerToken);
   const headers = new Headers();
   headers.append('Content-Type', 'application/json');
   headers.append('Authorization', headerToken);
   headers.append('Access-Control-Allow-Origin', '*');
    return this.http.get(environment.baseUrl + '/seller/mr',
    {headers: headers, params : {
     offset: '0',
     limit: '10'
    }})
    .map((response: Response) => {
     console.log(response.status);
     const user = response.json();
     user.responseStatus = response.status;
     console.log(user);
     return user;
   }).catch((error) => {
     console.log('error', error);
     if (error.status === 500) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     } else if (error.status === 400) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     } else if (error.status === 401) {
       console.log('status', error.status);
       const err = error.json();
       err.responseStatus = error.status;
       console.log('status', err.responseStatus);
       return Observable.throw(err);
     }
 });
   }

   public searchMR(search) {
    console.log('search', search.searchParam);
    console.log('offset', search.offsteParam);
    console.log('limit', search.limitParam);
    const token = localStorage.getItem('currentUser');
    console.log('token', token);
    const headerToken = 'Bearer ' + token;
    console.log('hk', headerToken);
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', headerToken);
    headers.append('Access-Control-Allow-Origin', '*');
     return this.http.get(environment.baseUrl + '/seller/mr',
     {headers: headers, params : {
      offset: 0,
      limit: search.limitParam,
      search: search.searchParam
     }})
     .map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
    }
}
